import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { paths } from '../../../common/constants/pathVariables';
import {
  EoeSelfRegistration,
  getEmployeeSelfRegistrationStateFromSession,
} from '../../../components/EoeSelfRegistration/EoeSelfRegistration.js';
import { PreAuthHeader } from '../../../components/PreAuthHeader/PreAuthHeader';

export const EoeSelfRegistrationPath = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { individualDetails } = location.state ?? {};
  const employeeSelfRegistrationState = getEmployeeSelfRegistrationStateFromSession();

  useEffect(() => {
    if (!individualDetails) {
      navigate(paths.EMPLOYEE_HOME);
    }
  }, [individualDetails, navigate]);

  return (
    <>
      <PreAuthHeader isEoe={true} individualDetails={individualDetails} />
      <EoeSelfRegistration employeeSelfRegistrationState={employeeSelfRegistrationState} />
    </>
  );
};
